import { NgModule } from '@angular/core';
import { AnalyticsModule } from '@flyfreely-portal-ui/analytics';
import { EnhancedHelpModule } from '@flyfreely-portal-ui/enhanced-help';
import { TooltipModule } from 'ngx-bootstrap/tooltip';
import { NewsCardComponent } from './news/news-card.component';
import { QuickSetupComponent } from './support/quick-setup/quick-setup.component';
import { SupportLinksComponent } from './support/support-links/support-links.component';

@NgModule({
    imports: [EnhancedHelpModule, AnalyticsModule, TooltipModule],
    declarations: [
        NewsCardComponent,
        QuickSetupComponent,
        SupportLinksComponent
    ],
    exports: [NewsCardComponent, QuickSetupComponent, SupportLinksComponent]
})
export class NewsModule {}
